// ============================================================
// accountAppearance.ts — keeps the theme choice on the ACCOUNT
// (User.appearance) so it follows the user across devices.
//   • Each fresh user record (GET / PATCH /api/auth/me → setAuthUser) that
//     carries an appearance → this device adopts it (and caches it for first
//     paint).
//   • The account has none yet (null) but this device has a saved choice
//     (e.g. the old per-device Dark mode switch) → it's uploaded once, so a
//     dark-mode user stays dark on their other devices.
// The login response doesn't carry the field (key absent) → nothing happens
// until getMe hydrates.
// ============================================================
import { updateMeApi } from '../api/casevoApi'
import { adoptAccountAppearance, readAppearance, type Appearance } from './theme'

let uploaded = false
const hasDeviceChoice = (): boolean => { try { return !!localStorage.getItem('casevo_theme') } catch { return false } }

export const syncAccountAppearance = (user: { appearance?: Appearance | null }): void => {
  if (!('appearance' in user)) return
  if (user.appearance) { adoptAccountAppearance(user.appearance); return }
  if (uploaded || !hasDeviceChoice()) return
  uploaded = true
  updateMeApi({ appearance: readAppearance() }).catch(() => { uploaded = false })
}

// Save a change made in Settings to the account.
export const saveAccountAppearance = (a: Appearance): Promise<unknown> => updateMeApi({ appearance: a })

// Tests only.
export const _resetAccountAppearanceUpload = (): void => { uploaded = false }
